export default {
  "filters": {
    "by_quarter": "By quarter",
    "growing": "Growing",
    "all_regions": "All regions",
    "all_cities": "All citeis",
    "by_region": "By regions / Republic level",
    "by_regions": "By regions",
    "by_employees": "By employees",
    "search": "Search",
    "by_region_count": "Number by region",
    "by_founders": "By founders",
    "by_activity": "By activity",
    "by_status": "Select a status",
    "sum": "Sum",
    "number": "Number",
  },
  'st_active': 'Active',
  'st_new': 'New',
  'st_removed': 'Removed',
  "year_2017": "2017",
  "year_2018": "2018",
  "year_2019": "2019",
  "year_2020": "2020",
  "year_2025": "2025",
  "year_2026": "2026",
  "header": {
    "title": "Unified Platform on Economic Indicators of IT-Park Residents",
    "search": "Search ..."
  },
  "permission": {
    "message": "You do not have access to this dashboard!",
    "login": "Go to login page"
  },
  "periods": {
    "all": "Period (whole period)",
    "all2": "whole period",
    "q1": "1 Quarter",
    "q2": "2 Quarter",
    "q3": "3 Quarter",
    "q4": "4 Quarter",
    "half": "First half of the year",
    "half2": "Second half of the year",
    "half2-5": "9 months",
  },
  "dashboard": {
    "number_of_residents": "Number of residents",
    "percent": "Percent",
    "number_of_employees": "Number of employees",
    "total_income": "Total income",
    "total_income_mlrd": "Total income (billion UZS)",
    "export_volume_usd": "Export volume",
    "export_volume_usd_mlrd": "Export volume (million USD)",
    "general_indicators": "General indicators",
    "report_indicators": "Report indicators",
    "analytical_indicators": "Analytical indicators",
    "audit_report_submission": "Audit report submission",
    "audit_not_submitted": "Residents who did not submit audit report",
    "tab_basic": "General indicators",
    "tab_report": "Report indicators",
    "tab_analytics": "Analytical indicators",
    "in_detail": "More details",
    "collections": "Collections",
    "quarterly_report_submission": "Quarterly report submission",
    "deduction_payment_info": "Deduction",
    "active_but_no_report": "Active residents who did not submit report",
    "those_who_were_deprived_of_residency_during_this_period": "Those who were residents during this period",
    "number_of_deregistered_residents": "Number of residents deregistered during this period",
    "deduction_payment_info_description": "Information on deduction payments",
    "must_submit_resident": "Residents who must submit report",
    "given": "Submitted",
    "un_given": "Not submitted",
    "returned_for_revision": "Returned for revision",
    "submitted": "Submitted",
    "debt_count": "Number of debts",
    "not_submitted": "Not submitted",
    "more_details": "More details",
    "virtual_office": "Virtual office",
    "large_companies": "Large companies",
    "count_companies": "Number of companies",
    "download_general_info": "Download all data on 'General indicators' in Excel",
    "virtual_office_contracts": "Residents with virtual office contracts",
    "large_turnover_info": "Information about residents with large turnover",
    "active": "Active",
    "revoked": "Revoked",
    "main_comparison": "Comparison",
    "export_comparison": "Comparison",
    "by_countries": "By countries",
    "main_indicator_comparison": "Comparison of main indicators for the same period",
    "export_vs_residence": "Export volume in relation to residency period",
    "export_share_by_countries": "Export share by countries",
    "it_visa": "IT VISA",
    "export": "Export",
    "foreign_capital_residents": "Residents with foreign capital involvement",
    "foreign_capital_residents_organizations": "Residents with foreign capital involvement",
    "it_visa_info": "Information about IT VISA",
    "export_by_activity": "Export volume by activity types",
    "foreign_organizations": "Foreign organizations",
    "download_report_info": "Download all data on 'Report indicators' in Excel",
    "it_park_rights": "IT Park Uzbekistan. All rights reserved",
    "residents_list": "List of residents",
    "active_residents_count": "Number of active residents",
    "is_active_residents_count": "Number of deregistered residents",
    "employee_count": "Number of employees",
    "exporters": "Exporters",
    "resident_info": "Information about residents",
    "employee_info": "Information about number of employees",
    "service_exporters_info": "Information about service exporters",
    "wage_amount": "Wage amount",
    "total_count": "Total count",
    "total_countries": "Number of countries"
  },

  "navigation": {
    "home": "Home",
    "reminders": "Reminders",
    "reports": "Reports",
    "graphical_view": "Graphical view",
    "general": "General",
    "residents": "Residents",
    "employees": "Employees",
    "exporters": "Exporters",
    "income": "Income",
    "table_view": "Table view",
    "extended_info": "Extended information",
    by_countries: "Economic information by country",
    "administrator": "Administrator"
  },
  "finance": {
    "total_income": "Total income",
    "search": "Search",
    "by_activity": "By activity",
    "by_region_amount": "Amount by region",
    "by_activity_types": "By types of activity",
    "active_13_5_trillion": "Active 13.5 trillion UZS",
    "total_amount": "Total income amount",
    "above_100b_soum": "Total income above 100 billion UZS",
    "between_50b_100b_soum": "Total income from 50 to 100 billion UZS",
    "between_1b_50b_soum": "Total income from 1 to 50 billion UZS",
    "below_1b_soum": "Total income below 1 billion UZS"
  },
  "filters_periods": {
    "select_period": "Select period for comparison:",
    "yearly_quarterly": "Yearly (quarterly)",
    "all": "All",
    "partial": "Partial",
    "income": "Income",
    "employee_count": "Number of employees",
    "export_amount": "Export amount",
    "resident_count": "Number of residents"
  },
  "advanced_filters": {
    "select_period": "Select period for comparison:",
    "yearly_quarterly": "Yearly (quarterly)",
    "all": "All",
    "partial": "Partial",
    "incomes": "Income",
    "employee_count": "Number of employees",
    "export_amount": "Export amount",
    "residents_count": "Number of residents",
    "employees_salary": "Wage amount",
    "incomes_10": "Turnover above 10 billion",
    "export_50": "Export share above 50%",
    "foreign_founder_residents": "Residents with foreign founders",
    "developers": "Number of developers",
    "incomes_100": "Turnover above 100 billion",
    "export_100": "100% export share",
    "new_residents": "Number of new residents",
    "foreign_employees": "Foreign employees",
    "virtual_office_contracts": "Residents with virtual office contracts",
    "out_residents": "Number of deregistered",
    "clear": "Clear",
    "generate_data": "Generate data",
    "employees": "Ходимлар",
  },
  "deduction": "Deduction",
  "balance": "Balance",
  "charged": "Charged",
  "paid": "Paid",
  "total_employees": "Total: 7,000 employees, 10 companies",
  "total_employee": "Total employees",
  "from_this": "of which",
  "serial_number": "No.",
  "organization_tin": "TIN",
  "organization_name": "Organization name",
  "region": "Region",
  "city": "City",
  "founder_country": "Founder country",
  "registration_date": "Registration date",
  "resident_status": "Resident status",
  "organization_type": "Organization type",
  "export_share": "Export share",
  "admin_staff": "Administrative staff",
  "core_staff": "Core staff",
  "developers": "Developers",
  "it_service_providers": "IT service providers",
  "teachers": "Teachers",
  "employee_count": "Number of employees",
  "mhtf": "MHTF",
  "period": "Period",
  "chart_view": "Chart view",
  "table_view": "Table view",
  "export_direction": "Export direction",
  "export_by_services": "Export by services",
  "eu_uk": "EU and UK",
  "cis_apac": "CIS & APAC",
  "total_export": "Total export",
  "north_america": "North America",
  "mena": "MENA",
  "founders_export_share": "Export share by founders",
  "residents_period": "Residents period",
  "up_to_year": "up to year",
  "search": "Search",
  "employees": "employees",
  "home": "Home",
  "reminders": "Reminders",
  "new": "New",
  "bpo": "BPO",
  "issued": "Issued",
  "general": "General",
  "residents": "Residents",
  "year_2021": "2021",
  "year_2022": "2022",
  "year_2023": "2023",
  "year_2024": "2024",
  "exporters": "Exporters",
  "export": "Export",
  "total_income": "Total income",
  "percentage_10": "10%",
  "percentage_30": "30%",
  "income_300m": "300 million",
  "table_view_detailed": "Detailed table view",
  "detailed_info": "Detailed information",
  "admin": "Administrator",
  "currency_trillion_soum": "trillion UZS",
  "currency_million": "million",
  "regions_view": "By regions / Republic level",
  "residents_view": "By residents",
  "region_based": "By region",
  "activity_based": "By activity",
  "founders_based": "By founders",
  "it_park": "IT Park",
  "software_dev": "Software development",
  "usa": "USA",
  "russia": "Russia",
  "samarkand": "Samarkand",
  "it_education": "IT education",
  "poland": "Poland",
  "top_5": "Top 5",
  "top_5_regions": "TОP-5 regions",
  "top_5_industry": "ТОP-5 Industry",
  "top_5_country": "ТOP-5 Country",
  "toshkent_region": "Tashkent region",
  "industry": "Industry",
  "vro": "VRO",
  "country": "Country",
  "germany": "Germany",
  "china": "China",
  "reports": "Reports",
  "bukhara": "Bukhara",
  "support": "Support",
  "graphical_view": "Graphical view",
  "fergana": "Fergana",
  "license_sales": "License sales",
  "top_5_growth": "Top 5 by growth",
  "andijan": "Andijan",
  "tashkent": "Tashkent",
  "administrative_staff": "Administrative staff",
  "living_status": "By sustainability",
  "registered": "Registered",
  "revoked_residents": "Revoked residents",
  "close": "close",
  "Работники, участвующие в основной (производственной)": "Employees involved in the main (production) activities",
  "Сотрудники оказывающие информационные услуги": "Employees providing information services",

  "Вход в кабинет": "Login",
  "Пользователь не найден": "User not found",
  "Такого пользователя нет.": "There is no such user.",
  "Проверьте введенные данные и повторите попытку.": "Please check the entered data and try again.",
  "вернуться к входу": "back to login",
  "Единая система идентификации (OneID) предназначена для простого и безопасного доступа пользователей к различным информационным системам электронного правительства и государственных органов.":
    "OneID is designed for easy and secure user access to various e-government and government information systems.",


  "Единая платформа экономических показателей резидентов ИТ-парка": "Unified platform for economic indicators of IT-Park residents",
  "поиск": "search",
  "Мой счет": "My account",
  "Период (весь период)": "Period (whole period)",
  "1 год": "1 year",
  "1 квартал": "1 quarter",
  "3 квартал": "3 quarter",
  "2 квартал": "2 Quarter",
  "Иностранные граждане являются работающими резидентами": "Foreign citizens are working residents",
  "4 квартал": "4 Quarter",
  "Ежегодно": "Yearly",
  "Ежеквартальный": "Quarterly",
  "Площадь (общая)": "Area (Total)",
  "Общий": "Total",
  "QR": "QR",
  "Андижанская область": "Andijan region",
  "Республика Каракалпакстан\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t": "Republic of Karakalpakstan\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
  "Бухарская область": "Bukhara region",
  "Джизакская область": "Jizzakh region",
  "Кашкадарьинская область": "Kashkadarya region",
  "Навоийская область": "Navoi region",
  "Наманганская область": "Namangan region",
  "Самаркандская область": "Samarkand region",
  "Сурхандарьинская область": "Surkhandarya region",
  "Сырдарьинская область": "Syrdarya region",
  "Ташкентская область": "Tashkent region",
  "Ферганская область": "Fergana region",
  "Хорезмская область": "Khorezm region",
  "город Ташкент": "Tashkent city",
  "млрд сум": "billion soums",
  "Количество жителей": "Number of residents",
  "Общий доход\r\n(млрд сумов)": "Total income \r\n(billion soums)",
  "Прочие доходы": "Other income",
  "Объем экспорта,\r\nмлн долл. США": "Export volume, \r\nmillion USD",
  "Объем экспорта": "Volume of export",
  "Общие показатели": "General indicators",
  "Аналитические индикаторы": "Analytical indicators",
  "Список резидентов": "Resident list",
  "Информация о резидентах": "Information about residents",
  "О численности сотрудников": "About the number of employees",
  "Размер заработной платы": "Salary amount",
  "Экспортеры": "Exporters",
  "Информация о поставщиках экспортных услуг": "Information about export service providers",
  "Количество стран": "Number of countries",
  "IT Park Uzbekistan. Все права защищены 2019-2024": "IT Park Uzbekistan. All rights reserved 2019-2024",
  "Представление аудиторского отчета": "Submission of audit report",
  "Те, кто не представил аудиторский отчет": "Those who have not submitted the audit report",
  "Брошенный": "Thrown",
  "Не представлено": "Not submitted",
  "подробно": "in detail",
  "Представление ежеквартального отчета": "Submission of quarterly report",
  "На практике они не подавали отчеты как резиденты": "In practice, they did not submit reports as residents",
  "Информация о плате за увольнение": "Information on the separation fee",
  "Задолженность": "Indebtedness",
  "Число": "Number",
  "Виртуальный офис": "Virtual office",
  "Резиденты с контрактом на виртуальный офис": "Residents with a virtual office contract",
  "На практике": "In practice",
  "Выпущенный": "Released",
  "Крупные предприятия": "Large enterprises",
  "Информация о резидентах с высокой текучестью кадров": "Information on residents with high turnover",
  "Выгрузить все данные по «Общему показателю» в Excel": "Download all data on the \"General indicator\" in Excel",
  "Домашняя страница": "Homepage",
  "Показатели отчета": "Report indicators",
  "Ежеквартальный отчет": "Quarterly report",
  "Агрегация": "Aggregation",
  "Информация (по возрастанию)": "Information (ascending)",
  "Имя за именем": "Name by name",
  "№": "T/r",
  "Районы": "Areas",
  "Сообщаемые жители": "Reportable residents",
  "Ведущие": "Presenters",
  "Возвращено для редактирования": "Returned for Editing",
  "Те, кто не представил": "Those who did not submit",
  "В процессе приёма": "During the admission process",
  "Всего по регионам": "Total by regions",
  "Скачать": "Download",
  "Выберите формат": "Select the format",
  "Сохранять": "Save",
  "Аудиторский отчет": "Audit report",
  "Сравнение": "Comparison",
  "Сравнение основных показателей с соответствующим периодом": "Comparison of key figures to the corresponding period",
  "Соотношение объема экспорта к периоду проживания": "The ratio of the volume of exports to the period of residence",
  "В разрезе штатов": "In the cross-section of states",
  "Доля экспорта по странам": "Share of exports by country",
  "Виза для собак": "DOG VISA",
  "Информация о IT VISA": "Information on IT VISA",
  "Экспорт": "Export",
  "Объем экспорта в разрезе видов деятельности": "Export volume in the section of types of activities",
  "Резиденты с участием иностранного капитала": "Residents with foreign capital participation",
  "Иностранные организации": "Foreign Organizations",
  "Загрузите всю информацию по «Показателям отчета» в Excel": "Download all the information on \"Report Indicators\" in Excel",
  "Разделение": "Separation",
  "На сегодняшний день статус": "To date status",
  "ПОМЕШИВАТЬ": "TIN",
  "Название организации": "Name of the organization",
  "Территория": "Territory",
  "Баланс": "Balance",
  "Рассчитано": "Calculated",
  "Оплаченный": "Paid",
  "Список Ташкентской области": "List of Tashkent region",
  "Название компании:": "Company name:",
  "Период:": "Period:",
  "Дата операции": "Date of operation",
  "Содержание операции": "Content of the operation",
  "Дата платежа": "Payment date",
  "Оборот в отчете": "Turnover in the report",
  "Рассчитано на оплату": "Calculated to pay",
  "Переплата": "Overpayment",
  "Город": "City",
  "Дата регистрации": "Date of registration",
  "Статус резидента": "Resident status",
  "Резидент": "Resident",
  "Тип организации": "Type of organization",
  "Государство-основатель": "Founding state",
  "Количество используемых жилых помещений": "Number of residences in use",
  "от этого": "from that",
  "дата платежа": "payment date",
  "Добавлено в этот период": "Added during this period",
  "Количество снятых с регистрации жителей": "Number of deregistered residents",
  "Лица, лишенные права проживания в этот период": "Those who were deprived of residency during this period",
  "Номер компании": "Company number",
  "Всего сотрудников": "Total employee",
  "Административный персонал": "Administrative staff",
  "MXTF": "MXTF",
  "Ключевой персонал": "Key staff",
  "Программисты": "Programmers",
  "Поставщики информационных услуг": "Information service providers",
  "Учителя": "Teachers",
  "Экспорт резидентов": "Exporting residents",
  "Учредители — иностранные резиденты": "Founders are foreign residents",
  "компания": "company",
  "Название организации и ИНН": "Organization name and TIN",
  "Дата резидентства": "Date of residence",
  "Территория и город": "Territory and City",
  "Страна регистрации и дата регистрации": "Country of Incorporation and Date of Registration",
  "Доля экспорта": "Export share",
  "Направление экспорта": "Export direction",
  "Графический вид": "Graphic view",
  "Стол": "Table",
  "Информация о резидентах с высоким оборотом": "Information on residents with high turnover",
  "В секторе экспортных услуг": "In the sector of export services",
  "Общий экспорт": "Total exports",
  "ИТ-услуги": "IT services",
  "ИТ-образование": "IT education",
  "Игровая разработка и креатив": "Gamedev & Creative",
  "Программные продукты": "Software products",
  "Основатели в разрезе доли экспорта": "Founders in the cross-section of export share",
  "Период резидентства": "Resident period",
  "Доход": "Income",
  "Расширенная информация": "Advanced information",
  "Администратор": "Administrator",
  "Примечания": "Notes",
  "Отчеты": "Reports",
  "В графическом виде": "In graphic form",
  "В табличном виде": "In table view",
  "В разделе территорий / в разделе Республики": "In the section of territories / in the section of the Republic",
  "Жители": "By residents",
  "По территории": "By territory",
  "По активности": "By activity",
  "По словам основателей": "According to the founders",
  "Развитие ДТ": "Development of DT",
  "Поддерживать": "Support",
  "Продажа лицензий": "Selling licenses",
  "По пригодности для жизни": "According to liveability",
  "Зарегистрировано": "Registered",
  "Исключен из резиденции": "Removed from residency",
  "Число в поперечном сечении территории": "The number in the cross-section of the territory",
  "В разделе учредителей": "In the section of the founders",
  "В разделе «Тип деятельности»": "In the Activity Type section",
  "По категориям сотрудников": "By category of employees",
  "В зависимости от размера заработной платы": "According to the salary amount",
  "Об иностранных гражданах": "On foreign citizens",
  "Основатель": "Founder",
  "Количество организаций с долей экспорта более 50 процентов": "The number of organizations with an export share of more than 50 percent",
  "По объему экспорта": "By revenue volume",
  "practice_text": "In practice, {amount} million soums. <br> The number is {count}",
  "practice_text2": "In practice, {amount} mln.dollar. <br> The number is {count}",
  "Доля суммы": "Share of amount",
  "Объем экспорта до 100 тыс. долларов2": "Export volume up to 50 thousand dollars",
  "Объем экспорта от 100 тыс. до 1 млн. за доллар2": "Export volume from 50 thousand to 5 million dollars",
  "Объем экспорта от 1 млн до 10 млн за доллар2": "Export volume from 5 to 10 million dollars",
  "Объем экспорта более 10 миллионов долларов2": "Export volume above 10 million dollars",
  "Объем экспорта более 10 миллионов долларов": "Total income volume exceeds 100 billion soums",
  "Объем экспорта от 1 млн до 10 млн за доллар": "Total income volume from 1 to 50 billion soums",
  "Объем экспорта от 100 тыс. до 1 млн. за доллар": "Total income volume from 50 to 100 billion soums",
  "Объем экспорта до 100 тыс. долларов": "Total income volume up to 1 billion soums",
  "В разделе стран-экспортеров": "In the section of exported countries",
  "ТОП-5 стран": "TOP-5 countries",
  "Сумма территории": "The sum of the territory",
  "Общий доход составляет более 100 млрд сумов.": "The total income is more than 100 billion soums",
  "Общий доход от 50 млрд сумов до 100 млрд сумов": "Total income is from 50 billion soums to 100 billion soums",
  "Общий доход от 1 млрд сумов до 50 млрд сумов.": "The total income is from 1 billion soums to 50 billion soums",
  "Общий доход до 1 млрд сумов": "Total income is up to 1 billion soums",
  "Выберите период для сравнения:": "Select the period to be compared:",
  "Ежегодно (ежеквартально)": "Annual (Quarterly)",
  "В разделе территории": "In the section of the territory",
  "Вид деятельности (все)": "Type of activity (all)",
  "Территория (вся)": "Territory (all)",
  "Страна экспорта (все)": "Export country (all)",
  "Основатели": "Founders",
  "Страны (все)": "States (all)",
  "Все": "Everything",
  "Частично": "Partially",
  "Выберите соответствующий индикатор:": "Select the appropriate indicator:",
  "Сумма экспорта": "Export amount",
  "Те, чей оборот превышает 10 млрд.": "Those whose turnover exceeds 10 billion",
  "На 50% больше экспортных поставок": "50% higher number of exports",
  "Количество резидентов с иностранным учредителем": "Number of residents with a foreign founder",
  "Количество программистов": "Number of programmers",
  "Экспорт 100% числа": "Export 100% number",
  "Количество новых жителей": "Number of new residents",
  "Иностранные сотрудники": "Foreign employees",
  "Количество подписавших соглашение о виртуальном офисе": "The number of signatories of the virtual office agreement",
  "Количество регистраций": "The number of registrations",
  "Очистить": "Clean up",
  "Формирование данных": "Data formation",
  "квартал": "quarter",
  "География экспорта": "Export Geography",
  "inp_fild": 'You can write your question of interest',

  "Выберите тип организации": "Select the type of organization",
  "Выберите страну": "Select a country",
  "Выберите день": 'Select a day',
  "Распределение экспорта": "Distribution of exports",

  "все резиденты": "all residents",
  "Все резиденты": "All residents",
  "Неэкспортеры": "No-exporters",

  "резиденты с иностранными учредителями": "residents with foreign founders",
  "резиденты без иностранных учредителей": "residents without foreign founders",


  "Название компании": "Company name",
  "Учредитель": "Founder",
  "Вид деятельности": "Type of activity",
  "География Экспорта": "Export Geography",
  "Кол-во сотрудников": "Number of employees",

  "за весь год": "for the whole year",
  "за x-квартал": "for {x}-quarter",
  "by_income": "By income",
  "by_indicator": "By indicators",
  "residents_required_to_submit_reports": "Residents required to submit reports",
  "submitted": "Submitted",
  "returned_for_editing": "Returned for editing",
  "not_submitted": "Not submitted",
  "totalDebtTitle": "Total Debt",
  "totalDebtInfo": "residents",
  "totalOverpaymentTitle": "Total Overpayment",
  "totalOverpaymentInfo": "residents",
  "accruedForThePeriodTitle": "Accrued for the Period",
  "accruedForThePeriodInfo": "residents",
  "numberOfResidentsTitle": "Number of Residents",
  "numberOfResidentsInfo": "Active Companies",
  "footer_rights": "IT Park Uzbekistan. All rights reserved 2019-2024",
  "1": "January",
  "2": "February",
  "3": "March",
  "4": "April",
  "5": "May",
  "6": "June",
  "7": "July",
  "8": "August",
  "9": "September",
  "10": "October",
  "11": "November",
  "12": "December",
  "all": "All",
  "resident": "Resident",
  "excluded": "Excluded",
  "select": "Choose",
  "search_inn": "Search by TIN",
  "export_table": "Extended-information",
  "inn": "TIN",
  "accrued": "Accrued",
  "overdue": "Overdue",
  "status": "Status",
  "show": "Show",
  "no_data_found": "No data found",
  "no_data": "No data",
  "financial_summary_on": "Financial summary as of",
  "opening_balance": "Opening balance",
  "accrued_for_period": "Accrued for the period",
  "paid_for_period": "Paid for the period",
  "total_debt": "Total debt",
  "overpayment": "Overpayment",
  "current_balance": "Current balance",
  "report_date": "Report date",
  "income": "Income",
  "payable": "Contribution amount",
  "payment_date": "Payment date",
  "days": "days",
  "Все статусы": "All statuses",
  "Оплачено": "Paid",
  "Задолженость": "Debt",
  "regions": "Region",

  "quarter_report": "Report for Q{quarter}",
  "день": "day",
  "дня": "days",
  "дней": "days",
  "table_parameters": "Please specify the parameters to generate the table",
  "main": "Main",
  "activity_types": "Activity types",
  "export_countries1": "Export countries",
  "regions1": "Regions",
  "countries": "Countries",
  "collapse": "Collapse",
  "indicators": "Indicators",
  "reset_filters": "Reset filters",
  "generate_table": "Generate table",
  "year": "year",
  "result": "Expand",
  "quantity": "Amount",
  "percent": "in %",
  "млрд. сум": "billion soums",
  "млн. дол. США": "million US dollars",
  "residents_count": "Total residents",
  "export_amount": "Export amount (US dollars)",
  "half_year": "Half Year",
  "yearly": "Yearly",
  "nine_months": "Nine Months",
  "Йиллик": "Yearly",
  "Ярим йиллик": "Half Year",
  "foreign_capital": "Residents with foreign capital participation",
  "exporting": "Residents engaged in export activities",
  "company_name": "Company name",
  "direction": "Direction",
  "detailed_information": "Detailed information",
  "date_of_application_of_the_benefit": "Date of application of the benefit",
  "Страна-экспортер": "Exported country",
  "more_th_50_percent": "Greater than 50%",
}